import { DARK_THEMES, DEFAULT_THEME, THEME_ART, THEME_COOKIE, THEMES } from './constants/theme';
import { swapArtFavicon } from './favicon';
import type { Theme } from './types/user';

const THEME_COOKIE_REGEX = new RegExp(`(?:^|; )${THEME_COOKIE}=([\\w-]+)`);

export const isTheme = (value: unknown): value is Theme => THEMES.includes(value as Theme);

export const resolveTheme = (value: unknown): Theme => (isTheme(value) ? value : DEFAULT_THEME);

export const themeFromCookie = (cookieHeader: string | undefined): Theme =>
  resolveTheme(cookieHeader?.match(THEME_COOKIE_REGEX)?.[1]);

export const themeScheme = (theme: Theme): 'light' | 'dark' =>
  DARK_THEMES.includes(theme) ? 'dark' : 'light';

export const injectThemeAttr = (html: string, theme: Theme): string => {
  const art = THEME_ART[theme];
  return swapArtFavicon(
    html.replace(
      /<html\b/i,
      `<html data-theme="${theme}" data-scheme="${themeScheme(theme)}" data-art="${art}"`
    ),
    art
  );
};
